import { ApiLearnerFileFileKindChoices } from "@api/graphql/types-and-hooks";
import { ABLLS_LAYOUT, AFLS_LAYOUT } from "@components/AssessmentFormRenderer/layouts/ablls";
import { ADI_R_LAYOUT } from "@components/AssessmentFormRenderer/layouts/adiR";
import { ADI_R_TODDLER_LAYOUT } from "@components/AssessmentFormRenderer/layouts/adiRToddler";
import { BDI3_LAYOUT } from "@components/AssessmentFormRenderer/layouts/bdi3";
import { BHI_LAYOUT } from "@components/AssessmentFormRenderer/layouts/bhi";
import { CARS_2_LAYOUT } from "@components/AssessmentFormRenderer/layouts/cars2";
import { EARLIPOINT_LAYOUT } from "@components/AssessmentFormRenderer/layouts/earlipoint";
import { KBIT_2_LAYOUT } from "@components/AssessmentFormRenderer/layouts/kbit2";
import { RIAS_2_LAYOUT } from "@components/AssessmentFormRenderer/layouts/rias2";
import type { AssessmentLayoutConfig } from "@components/AssessmentFormRenderer/types/layoutTypes";

export const ASSESSMENT_CONFIGS: Record<string, AssessmentLayoutConfig> = {
  [ApiLearnerFileFileKindChoices.Cars_2]: CARS_2_LAYOUT,
  [ApiLearnerFileFileKindChoices.AdiR]: ADI_R_LAYOUT,
  [ApiLearnerFileFileKindChoices.AdiRToddler]: ADI_R_TODDLER_LAYOUT,
  [ApiLearnerFileFileKindChoices.Rias_2]: RIAS_2_LAYOUT,
  [ApiLearnerFileFileKindChoices.Ablls]: ABLLS_LAYOUT,
  [ApiLearnerFileFileKindChoices.Afls]: AFLS_LAYOUT,
  [ApiLearnerFileFileKindChoices.Earlipoint]: EARLIPOINT_LAYOUT,
  [ApiLearnerFileFileKindChoices.Kbit_2]: KBIT_2_LAYOUT,
  [ApiLearnerFileFileKindChoices.Bdi_3]: BDI3_LAYOUT,
  [ApiLearnerFileFileKindChoices.Bhi]: BHI_LAYOUT,
};
